import axios from 'axios';
import providerTransformer from '../../transformers/providerProfile';
import tableUtil from '../../utils/table';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    let params = query || {};

    axios.get(process.env.VUE_APP_API_ADMIN_LOCATION + 'providers', { params }).then(
      ({ data }) => {
        let dataRes = {};
        dataRes.data = providerTransformer.fetchCollectionWithPayment(data.data);
        dataRes.meta = data.pagination ? { pagination: data.pagination } : tableUtil.mockupMeta(dataRes.data.length);
        resolve(dataRes);
      },
      (error) => {
        console.log(error);
        reject(error);
      }
    );
  });

  return promise;
};
